function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LeaderboardAvatar = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _View = require("../../../View");
var Icons = _interopRequireWildcard(require("../../../Icons"));
var _reactNative = require("react-native-web");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var LeaderboardAvatar = exports.LeaderboardAvatar = (0, _react.memo)(function (_ref) {
  var value = _ref.value,
    _ref$showCrown = _ref.showCrown,
    showCrown = _ref$showCrown === void 0 ? false : _ref$showCrown,
    label = _ref.label;
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  return (0, _jsxRuntime.jsx)(_View.View, {
    testID: "LeaderboardAvatar",
    style: [showCrown && styles.container_crown],
    children: (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [showCrown ? (0, _jsxRuntime.jsx)(Icons.Crown, {
        style: styles.crown
      }) : null, value ? (0, _jsxRuntime.jsx)(_reactNative.Image, {
        source: {
          uri: value
        },
        style: styles.avatar,
        testID: "LeaderboardAvatarImage",
        accessibilityLabel: "".concat(label, " avatar")
      }) : (0, _jsxRuntime.jsx)(_View.View, {
        style: styles.defaultAvatar,
        testID: "LeaderboardAvatarDefault",
        children: (0, _jsxRuntime.jsx)(_reactNative.Text, {
          style: styles.defaultAvatarText,
          children: label == null ? void 0 : label.substring(0, 1)
        })
      })]
    })
  });
});